import Vue from 'vue'
import Router from 'vue-router'
import index from '../views/index'
import search from '../views/search'
import JobDetails from '../views/jobDetails'
import enterpriseDetails from '../views/enterpriseDetails'
import information from '../views/information'
import informationDetail from '../views/informationDetail'
import personalCore from '../views/jobSeekers/personalCore'
import resume from '../views/jobSeekers/resume'
import editResume from '../views/jobSeekers/editResume'
import myCollection from '../views/jobSeekers/myCollection'
import enterpriseIndex from '../views/enterprise/enterpriseIndex'
import curriculumVitae from '../views/enterprise/curriculumVitae'
import enditJob from '../views/enterprise/enditJob'
import resumeDetail from '../views/enterprise/resumeDetail'
import enterpriseInformation from '../views/enterprise/enterpriseInformation'
import releaseJob from '../views/enterprise/releaseJob'
import resumeSuggest from '../views/enterprise/resumeSuggest'
import jobLists from '../views/enterprise/jobLists'
import myEnroll from '../views/jobSeekers/myEnroll'
import registercom from '../views/jobSeekers/registercom'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/search',
      name: 'search',
      component: search
    },
    {
      path: '/jobDetails',
      name: 'JobDetails',
      component: JobDetails
    },
    {
      path: '/enterpriseDetails',
      name: 'enterpriseDetails',
      component: enterpriseDetails
    },
    {
      path: '/information',
      name: 'information',
      component: information
    },
    {
      path: '/informationDetail',
      name: 'informationDetail',
      component: informationDetail
    },
    {
      path: '/personalCore',
      name: 'personalCore',
      component: personalCore
    },
    {
      path: '/resume',
      name: 'resume',
      component: resume
    },
    {
      path: '/editResume',
      name: 'editResume',
      component: editResume
    },
    {
      path: '/myCollection',
      name: 'myCollection',
      component: myCollection
    },
    {
      path: '/enterpriseIndex',
      name: 'enterpriseIndex',
      component: enterpriseIndex
    },
    {
      path: '/curriculumVitae',
      name: 'curriculumVitae',
      component: curriculumVitae
    },
    {
      path: '/enterpriseInformation',
      name: 'enterpriseInformation',
      component: enterpriseInformation
    },
    {
      path: '/resumeSuggest',
      name: 'resumeSuggest',
      component: resumeSuggest
    },
    {
      path: '/releaseJob',
      name: 'releaseJob',
      component: releaseJob
    },
    {
      path: '/jobLists',
      name: 'jobLists',
      component: jobLists
    },
    {
      path: '/myEnroll',
      name: 'myEnroll',
      component: myEnroll
    },
    {
      path: '/enditJob',
      name: 'enditJob',
      component: enditJob
    },
    {
      path: '/resumeDetail',
      name: 'resumeDetail',
      component: resumeDetail
    },
    {
      path: '/registercom',
      name: 'registercom',
      component: registercom
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js